import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import UpdateMediaDetail from "../../components/admincomponents/UpdateMediaDetail";

function UpdateMedia({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <UpdateMediaDetail />            
    </>
  );
}

export default UpdateMedia;
